import { FC, ReactNode } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface ModalBackgroundProps {
  children: ReactNode;
  name: string;
  title?: string;
  className?: string;
  wrapperClassName?: string;
}

export const ModalContent: FC<ModalBackgroundProps> = ({
  children,
  className = '',
  wrapperClassName = '',
  name,
  title,
}) => {
  return (
    <div
      className={mergeClasses(
        'flex-center fixed left-0 top-0 z-50 h-screen w-screen bg-black/65 lg:p-4',
        wrapperClassName,
      )}
    >
      <div
        className={mergeClasses('w-screen rounded-2xl bg-white px-4 py-6 md:px-12', className)}
        id={name}
      >
        {title && <h3 className="mb-6 text-center text-xl font-bold">{title}</h3>}
        {children}
      </div>
    </div>
  );
};
